import Anchor from "@components/Util/Anchor";
import Layout from "@components/Layout";

interface IProps {
  title: string;
  description: string;
  url: string;
  image?: string;
}

const Portfolio = ({ title, description, url, image }: IProps) => {
  return (
    <div className="bg-white border rounded-lg shadow-lg mb-8 overflow-hidden inline-block mr-4 max-w-sm max-h-full">
      {image && <img src={image} className="w-full object-cover h-32" />}
      <div className="p-4 md:p-8">
        <h2 className="text-2xl font-bold line leading-10 mb-4">{title}</h2>
        <p className="mb-4">{description}</p>

        <Anchor href={url}>
          <span className="text-blue-500 hover:text-blue-600">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="w-4 inline mr-1"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                clipRule="evenodd"
              />
            </svg>
            Check it out
          </span>
        </Anchor>
      </div>
    </div>
  );
};

export default Portfolio;
